import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Alert, ListGroup, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getAllCompanies } from '../../api/companyApi';
import Profile from '../../components/student/Profile';

const StudentDashboard = () => {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const data = await getAllCompanies();
        setCompanies(data || []);
      } catch (error) {
        console.error('Error fetching companies:', error);
        setError('Failed to fetch companies. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  if (!user.can_access_portal) {
    return (
      <Container className="py-5">
        <Alert variant="warning">
          <Alert.Heading>Access Restricted</Alert.Heading>
          <p>
            Your account doesn't have access to the placement portal yet. This could be because:
          </p>
          <ul>
            <li>The placement season hasn't officially started</li>
            <li>Your eligibility is still being verified</li>
            <li>There might be pending requirements or dues</li>
          </ul>
          <hr />
          <p className="mb-0">
            Please check back later or contact the Placement Unit for more information.
          </p>
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <h1 className="mb-4">Student Dashboard</h1>
      
      <Row>
        <Col md={4}>
          <Profile />
        </Col>
        
        <Col md={8}>
          <Card className="mb-4">
            <Card.Header as="h5">Announcements</Card.Header>
            <Card.Body>
              <Alert variant="info">
                <Alert.Heading>Welcome to the Placement Portal</Alert.Heading>
                <p>
                  Please make sure to submit your company preferences before the deadline. 
                  Once submitted, you can NOT update them.
                </p>
              </Alert>
            </Card.Body>
          </Card>
          
          <Card className="mb-4">
            <Card.Header as="h5">Upcoming Companies</Card.Header>
            <Card.Body>
              {loading ? (
                <div className="text-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                <Alert variant="danger">{error}</Alert>
              ) : companies.length === 0 ? (
                <Alert variant="secondary">No companies scheduled at the moment.</Alert>
              ) : (
                <ListGroup>
                  {companies.slice(0, 5).map((company) => (
                    <ListGroup.Item key={company.id} className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{company.name}</strong>
                        <div className="text-muted small">
                          Visit Date: {new Date(company.visit_date).toLocaleDateString()}
                        </div>
                      </div>
                      <Badge bg="primary" pill>
                        {company.rounds?.length || 0} Rounds
                      </Badge>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
              
              <div className="mt-3">
                <Link to="/preferences" className="btn btn-primary">
                  Submit Preferences
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default StudentDashboard;